import React, { useState } from "react";
import { useIsMobile } from "../../../hooks/useIsMobile";

interface TabProps {
    tabs: string[];
    subTab: string[];
    tabContents: React.ReactNode[];
    subTabContents: React.ReactNode[];
    selectedTabIndex: number;
    onTabChange?: (index: number) => void;
    activeSubTab?: number;
    onSubTabChange?: (index: number) => void;
}

const MypageTab: React.FC<TabProps> = ({
    tabs, subTab, selectedTabIndex, tabContents, subTabContents,
    onTabChange, activeSubTab: externalSubTab, onSubTabChange
}) => {
    const isMobile = useIsMobile();
    const [internalSubTab, setInternalSubTab] = useState<number>(0);
    const activeSubTab = externalSubTab !== undefined ? externalSubTab : internalSubTab;

    const handleTabClick = (index: number) => {
        if (onTabChange) onTabChange(index);
    };

    const handleSubTabClick = (index: number) => {
        setInternalSubTab(index);
        if (onSubTabChange) onSubTabChange(index);
    };

    return (
        <div className="flex flex-col gap-8 w-full">
            {/* 레벨1 탭 */}
            <div className="flex flex-row gap-8 md:gap-5 w-full border-b border-[#efefef] pb-0">
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        onClick={() => handleTabClick(index)}
                        className={`cursor-pointer transition-colors pb-4 border-b-2 ${
                            isMobile ? "text-[18px]" : "text-[22px]"
                        } ${
                            selectedTabIndex === index
                                ? "font-bold text-[#1f2937] border-[#1f2937]"
                                : "font-semibold text-[#aaa] border-transparent"
                        }`}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* 보관함 서브탭 - 필 스타일 */}
            {tabs[selectedTabIndex] === '보관함' && subTab.length > 0 && (
                <div className={isMobile ? "grid grid-cols-3 gap-2 w-full" : "flex flex-row gap-2"}>
                    {subTab.map((tab, index) => (
                        <button
                            key={index}
                            onClick={() => handleSubTabClick(index)}
                            className={`cursor-pointer transition-all py-2 rounded-full font-semibold border text-center ${
                                isMobile
                                    ? "text-[12px] px-1 w-full"
                                    : "text-[14px] px-6 w-auto"
                            } ${
                                activeSubTab === index
                                    ? "bg-[#19cf7a] border-[#19cf7a] text-white shadow-[0px_4px_8px_rgba(25,207,122,0.3)]"
                                    : "bg-white border-[#e0e0e0] text-[#888] hover:border-[#19cf7a] hover:text-[#19cf7a]"
                            }`}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
            )}

            {/* 콘텐츠 */}
            <div className="w-full">
                {tabs[selectedTabIndex] === '보관함'
                    ? subTabContents[activeSubTab]
                    : tabContents[selectedTabIndex]
                }
            </div>
        </div>
    );
};

export default MypageTab;
